import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { useDocumentHead } from '@/hooks/useDocumentHead';
import { videoCategories, featuredVideos, trendingList, articles, faqData } from '@/mocks/douhuaData';

function HomeSEO() {
  useDocumentHead({
    title: '豆花视频 - 免费在线观看高清影视 | 西瓜视频芒果视频丝瓜视频',
    description: '豆花视频🔎免费在线观看，汇集西瓜视频免费、免费视频网站91、🎥芒果视频等资源，高清不缓冲，电视剧全集电影大全免费看。',
    keywords: '豆花视频,免费在线观看,西瓜视频免费,芒果视频,丝瓜视频,高清视频,不缓冲,电视剧全集,电影大全,免费影视',
    canonicalUrl: 'https://douhua.example.com/',
  });

  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '豆花视频 - 免费在线观看高清影视',
    description: '豆花视频免费在线观看，汇集西瓜视频免费、芒果视频、丝瓜视频等资源，高清不缓冲，电视剧全集电影大全免费看。',
    url: 'https://douhua.example.com/',
  };

  return (
    <script type="application/ld+json">{JSON.stringify(homeSchema)}</script>
  );
}

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <HomeSEO />
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=a%20cinematic%20movie%20theater%20interior%20with%20warm%20red%20velvet%20curtains%20and%20golden%20stage%20lighting%2C%20elegant%20classic%20cinema%20atmosphere%2C%20dark%20background%20with%20warm%20accent%20lights%2C%20grand%20composition&width=1920&height=800&seq=douhua-hero-bg&orientation=landscape"
            alt="豆花视频 - 免费在线观看高清影视"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>
          <div className="relative z-10 flex flex-col items-center justify-center h-full w-full px-4 text-center">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
              免费在线观看，高清不缓冲
            </h1>
            <p className="text-base md:text-lg text-background-200 max-w-2xl mb-8 leading-relaxed">
              汇集西瓜视频免费、芒果视频、丝瓜视频等优质资源<br className="hidden sm:block" />
              电影大全 · 电视剧全集 · 综艺娱乐 · 动漫动画 — 全部免费看
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/category/movie"
                className="px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-all cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>开始观影
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 rounded-full font-medium text-sm whitespace-nowrap hover:bg-background-50/30 transition-all cursor-pointer border border-background-50/30"
              >
                <i className="ri-information-line mr-2"></i>了解更多
              </Link>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">海量内容，随心选择</h2>
              <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">六大内容分类，覆盖电影、电视剧、综艺、动漫、纪录片和短视频，满足你的所有观影需求</p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
              {videoCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group flex flex-col items-center p-5 rounded-xl bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
                >
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all mb-3">
                    <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">{cat.name}</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Videos */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">精选推荐</h2>
                <p className="text-sm text-foreground-500 mt-1">编辑团队为你精选的优质内容</p>
              </div>
              <Link to="/category/movie" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer">
                查看全部 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
              {featuredVideos.map((video) => (
                <Link
                  key={video.id}
                  to={`/article/${video.id}`}
                  className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 transition-all cursor-pointer"
                >
                  <div className="relative w-full h-44 md:h-48 overflow-hidden">
                    <img
                      src={video.image}
                      alt={`${video.title} - 豆花视频免费在线观看`}
                      title={`${video.title} - 豆花视频免费在线观看`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
                      {video.duration}
                    </div>
                    <div className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
                      {video.rating}
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="font-medium text-foreground-900 text-sm md:text-base mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {video.title}
                    </h3>
                    <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{video.description}</p>
                    <div className="flex items-center gap-3 text-xs text-foreground-400">
                      <span className="bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full whitespace-nowrap">{video.categoryName}</span>
                      <span>{video.views} 次播放</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Trending + Articles */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* Trending List */}
              <div className="lg:col-span-1">
                <div className="flex items-center gap-2 mb-6">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                    <i className="ri-fire-line text-lg"></i>
                  </div>
                  <h2 className="text-xl font-heading font-bold text-foreground-900">热播榜单</h2>
                </div>
                <div className="bg-background-100 rounded-xl p-4 border border-background-200">
                  {trendingList.map((item, idx) => (
                    <Link
                      key={item.id}
                      to={`/article/${item.id}`}
                      className={`flex items-center gap-3 py-3 cursor-pointer group ${
                        idx < trendingList.length - 1 ? 'border-b border-background-200' : ''
                      }`}
                    >
                      <span className={`w-6 h-6 flex items-center justify-center rounded-md text-xs font-bold whitespace-nowrap ${
                        item.rank <= 3
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-background-200 text-foreground-500'
                      }`}>
                        {item.rank}
                      </span>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm text-foreground-800 truncate group-hover:text-primary-500 transition-colors">{item.title}</p>
                        <span className="text-xs text-foreground-400">{item.category}</span>
                      </div>
                      <span className="text-xs whitespace-nowrap text-accent-600 font-medium">{item.hot}</span>
                    </Link>
                  ))}
                </div>
              </div>

              {/* Latest Articles */}
              <div className="lg:col-span-2">
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                      <i className="ri-article-line text-lg"></i>
                    </div>
                    <h2 className="text-xl font-heading font-bold text-foreground-900">最新资讯</h2>
                  </div>
                </div>
                <div className="space-y-4">
                  {articles.slice(0, 4).map((article) => (
                    <Link
                      key={article.id}
                      to={`/article/${article.id}`}
                      className="flex flex-col sm:flex-row gap-4 p-4 bg-background-100 rounded-xl border border-background-200 hover:border-primary-300 transition-all cursor-pointer group"
                    >
                      <div className="w-full sm:w-40 h-24 flex-shrink-0 rounded-lg overflow-hidden">
                        <img
                          src={article.image}
                          alt={article.title}
                          title={article.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 mb-1 flex-wrap">
                          <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full whitespace-nowrap">{article.category}</span>
                          <span className="text-xs text-foreground-400">{article.date}</span>
                        </div>
                        <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-1 line-clamp-2 group-hover:text-primary-500 transition-colors">
                          {article.title}
                        </h3>
                        <p className="text-xs text-foreground-500 line-clamp-2">{article.excerpt}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Bar */}
        <section className="py-10 bg-primary-500">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
              {[
                { value: '3000万+', label: '月活跃用户' },
                { value: '10万+', label: '影视资源' },
                { value: '5000万+', label: '日均播放量' },
                { value: '98.6%', label: '用户好评率' },
              ].map((stat, idx) => (
                <div key={idx}>
                  <p className="text-3xl md:text-4xl font-bold text-background-50 dark:text-foreground-950">{stat.value}</p>
                  <p className="text-sm text-background-200 dark:text-foreground-800 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">常见问题</h2>
              <p className="text-sm text-foreground-500">关于豆花视频，你想知道的都在这里</p>
            </div>
            <div className="space-y-3">
              {faqData.map((faq, idx) => (
                <details key={idx} className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                    <h4 className="text-sm md:text-base font-medium text-foreground-800 pr-4">{faq.question}</h4>
                    <i className="ri-add-line text-foreground-400 group-open:hidden flex-shrink-0"></i>
                    <i className="ri-subtract-line text-foreground-400 hidden group-open:block flex-shrink-0"></i>
                  </summary>
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
            <script type="application/ld+json">
              {JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'FAQPage',
                mainEntity: faqData.map((faq) => ({
                  '@type': 'Question',
                  name: faq.question,
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: faq.answer,
                  },
                })),
              })}
            </script>
          </div>
        </section>

        {/* CTA */}
        <section className="py-14 md:py-20 relative overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=a%20warm%20cozy%20home%20theater%20room%20with%20a%20large%20screen%20and%20comfortable%20seating%2C%20soft%20ambient%20lighting%2C%20golden%20warm%20tones%2C%20cinematic%20atmosphere%2C%20elegant%20interior%20design&width=1920&height=600&seq=douhua-cta-bg&orientation=landscape"
            alt="立即开始观影"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
          <div className="relative z-10 text-center px-4">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">立即开始你的观影之旅</h2>
            <p className="text-sm md:text-base text-background-200 mb-8 max-w-xl mx-auto">海量影视资源，高清流畅播放，全部免费 — 就在豆花视频</p>
            <Link
              to="/category/movie"
              className="inline-flex px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-all cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>免费观影
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}